/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FileDownloadResponse } from '../models/FileDownloadResponse';
import type { FileResponse } from '../models/FileResponse';
import type { PaginatedResponse } from '../models/PaginatedResponse';
import type { PaginatedResponse_FileResponse_ } from '../models/PaginatedResponse_FileResponse_';
import type { PresignedUploadRequest } from '../models/PresignedUploadRequest';
import type { PresignedUploadResponse } from '../models/PresignedUploadResponse';
import type { TaskFilesResponse } from '../models/TaskFilesResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class FileService {
    /**
     * List Files By Target
     * 대상별 파일 목록 조회
     *
     * 특정 대상에 연결된 파일들을 페이징하여 조회합니다.
     *
     * Args:
     * target_id: 대상 ID
     * target_type: 관련 타입으로 필터링 (선택사항)
     * @returns PaginatedResponse_FileResponse_ OK
     * @throws ApiError
     */
    public static appsFileViewsListFilesByTarget({
        targetId,
        targetType,
        page = 1,
        perPage = 100,
    }: {
        targetId: string,
        targetType?: string,
        page?: number,
        perPage?: number,
    }): CancelablePromise<PaginatedResponse_FileResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/file/by-target/{target_id}',
            path: {
                'target_id': targetId,
            },
            query: {
                'target_type': targetType,
                'page': page,
                'per_page': perPage,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List Files By Task
     * Task별 파일 목록 조회 (TaskItem 그룹핑)
     *
     * 특정 Task에 연결된 모든 TaskItem들의 파일을 TaskItem별로 그룹핑하여 조회합니다.
     *
     * Args:
     * task_id: Task의 UUID
     *
     * Returns:
     * TaskFilesResponse: Task 정보와 TaskItem별 파일 목록
     * @returns TaskFilesResponse OK
     * @throws ApiError
     */
    public static appsFileViewsListFilesByTask({
        taskId,
    }: {
        taskId: string,
    }): CancelablePromise<TaskFilesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/file/by-task/{task_id}',
            path: {
                'task_id': taskId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Download Business Files As Zip
     * Business별 파일 zip 다운로드
     *
     * 특정 Business에 연결된 모든 Task들의 TaskItem 파일을
     * zip 파일로 압축하여 다운로드합니다.
     *
     * 파일 구조:
     * business_name/
     * task_name_1/
     * task_item_name_1/
     * file1.pdf
     * file2.docx
     * task_item_name_2/
     * file3.xlsx
     * task_name_2/
     * ...
     *
     * Args:
     * business_id: Business의 UUID
     * start_date: 시작일 (Optional, YYYY-MM-DD 형식, 한국 시간 기준)
     * end_date: 종료일 (Optional, YYYY-MM-DD 형식, 한국 시간 기준)
     *
     * Note:
     * start_date와 end_date는 둘 다 없거나 둘 다 있어야 합니다.
     * File의 created_at 기준으로 필터링됩니다.
     *
     * Returns:
     * FileResponse: Zip 파일 다운로드 응답
     * @returns any OK
     * @throws ApiError
     */
    public static appsFileViewsDownloadBusinessFilesAsZip({
        businessId,
        startDate,
        endDate,
    }: {
        businessId: string,
        startDate?: (string | null),
        endDate?: (string | null),
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/file/by-business/{business_id}',
            path: {
                'business_id': businessId,
            },
            query: {
                'start_date': startDate,
                'end_date': endDate,
            },
        });
    }
    /**
     * Bulk Delete Files
     * 여러 파일 일괄 삭제
     *
     * 여러 파일을 한 번에 삭제합니다.
     *
     * Args:
     * file_ids: 삭제할 파일 ID 목록
     * @returns any OK
     * @throws ApiError
     */
    public static appsFileViewsBulkDeleteFiles({
        requestBody,
    }: {
        requestBody: Array<string>,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/file/bulk-delete',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get Presigned Upload Url
     * 파일 업로드용 Presigned URL 생성
     *
     * 클라이언트가 파일을 직접 스토리지에 업로드할 수 있는
     * 사전 서명된 URL을 생성합니다.
     *
     * Args:
     * data: 파일 업로드 요청 정보 (파일명, 크기, 타입, 관련 정보)
     *
     * Returns:
     * 업로드 URL과 필요한 메타데이터
     * @returns PresignedUploadResponse OK
     * @throws ApiError
     */
    public static appsFileViewsGetPresignedUploadUrl({
        requestBody,
    }: {
        requestBody: PresignedUploadRequest,
    }): CancelablePromise<PresignedUploadResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/file/presigned-upload',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List Files
     * 파일 목록 조회 및 검색
     *
     * 파일을 페이징하여 조회합니다. 검색 키워드가 제공되면 검색을 수행합니다.
     *
     * Args:
     * q: 검색 키워드 (선택사항) - 관련 모델, 사용 타입, 대상 ID, 파일 경로로 검색
     * relate_model: 관련 모델로 필터링 (선택사항)
     * using_type: 사용 타입으로 필터링 (선택사항)
     * @returns PaginatedResponse OK
     * @throws ApiError
     */
    public static appsFileViewsListFiles({
        q,
        targetType,
        page = 1,
        perPage = 100,
    }: {
        q?: string,
        targetType?: string,
        page?: number,
        perPage?: number,
    }): CancelablePromise<PaginatedResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/file',
            query: {
                'q': q,
                'target_type': targetType,
                'page': page,
                'per_page': perPage,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get File
     * 파일 정보 조회
     *
     * ID로 특정 파일 정보를 조회합니다.
     * @returns FileResponse OK
     * @throws ApiError
     */
    public static appsFileViewsGetFile({
        fileId,
    }: {
        fileId: string,
    }): CancelablePromise<FileResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/file/{file_id}',
            path: {
                'file_id': fileId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Delete File
     * 파일 삭제
     *
     * 특정 파일을 삭제합니다. (실제 파일과 DB 레코드 모두 삭제)
     * @returns void
     * @throws ApiError
     */
    public static appsFileViewsDeleteFile({
        fileId,
    }: {
        fileId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/file/{file_id}',
            path: {
                'file_id': fileId,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Download File
     * 파일 다운로드 URL 생성
     *
     * 특정 파일의 다운로드 URL을 생성합니다.
     * ENV_MODE에 따라 S3 또는 MinIO의 presigned URL을 반환합니다.
     * @returns FileDownloadResponse OK
     * @throws ApiError
     */
    public static appsFileViewsDownloadFile({
        fileId,
    }: {
        fileId: string,
    }): CancelablePromise<FileDownloadResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/file/{file_id}/download',
            path: {
                'file_id': fileId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
